// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"588":"reactTourismRating01","691":"reactTourismRatingSeal01"}[chunkId] || chunkId) + "." + {"480":"332e1be3","588":"03151bd5","691":"bb4a7fd5"}[chunkId] + ".chunk.js";
};